import { MenuListComponentProps } from "react-select"
import React from "react"
import styles from "./MenuList.module.scss"

type MenuListProps<OptionType, isMulty extends boolean> = MenuListComponentProps<OptionType, isMulty>

const MenuList = <OptionType, T extends boolean>(props: MenuListProps<OptionType, T>) => {
    const handleScroll: React.UIEventHandler<HTMLDivElement> = event => {
        const { scrollTop, scrollHeight, clientHeight } = event.currentTarget
        const scrollHandler = props.selectProps.onMenuScrollToBottom
        if (scrollTop + clientHeight >= scrollHeight - 1 && scrollHandler) {
            scrollHandler(event)
        }
    }

    return (
        <div className={styles.menuList} onScroll={handleScroll}>
            {props.children}
        </div>
    )
}

export default MenuList
